import { useCallback, useMemo } from 'react';

import ROUTES from '@/common/routes';
import { QueryKeys, useHistory } from '@/modules/core/hooks';

import { OrganizationAncestor, OrganizationAncestorLevel, OrganizationPathItem } from '../UnappliedFunds.types';

const getObservingQueryKey = (level: OrganizationAncestorLevel) =>
  ({
    partnerId: QueryKeys.OBSERVING_PARTNER_QUERY_KEY,
    distributorId: QueryKeys.OBSERVING_DISTRIBUTOR_QUERY_KEY,
    employerId: QueryKeys.OBSERVING_EMPLOYER_QUERY_KEY,
  })[level];

interface Params {
  ancestors: OrganizationAncestor[];
}

export const useOrganizationPath = ({ ancestors }: Params) => {
  const { originPush } = useHistory();

  const pathItems = useMemo(
    () =>
      ancestors.reduce<OrganizationPathItem[]>(
        (items, { id, name }) => (name ? [...items, { id, name }] : items),
        []
      ),
    [ancestors]
  );

  const handleSelectOrganization = useCallback(
    (organizationId: string) => {
      const selectedIndex = ancestors.findIndex(({ id }) => id === organizationId);
      const params = new URLSearchParams();
      ancestors.slice(0, selectedIndex + 1).forEach(({ id, level }) => {
        params.set(getObservingQueryKey(level), id);
      });
      originPush(`${ROUTES.HOME}?${params.toString()}`);
    },
    [ancestors, originPush]
  );

  return { pathItems, handleSelectOrganization };
};
